module.exports = __webpack_public_path__ + "img/ep-8.222d16c5.jpg";